<div class="two-column-search-layout">
  <!-- Header Container -->
  <ng-content select=".search-layout-header"></ng-content>

  <!-- Two-Column Layout -->
  <platform-page-container [fullscreen]="false" [contentSpacing]="false">
    <!-- Page Container Header Container -->
    <ng-content
      select=".search-layout-page-container-filters-header"
    ></ng-content>
    <div fxHide.lt-md>
      <div class="margin top-2x" platformEmptyHide>
        <ng-content select=".search-layout-page-container-header"></ng-content>
      </div>
    </div>

    <div
      class="search-layout-columns"
      *ngIf="!isLoading && hasResults"
      [fxLayout]="reverseColumns ? 'row-reverse' : 'row'"
      [fxLayout.lt-md]="reverseColumnsMobile ? 'column-reverse' : 'column'"
      fxLayoutGap="24px"
      ngClass.gt-sm="margin y-3x"
    >
      <div fxFlex.gt-sm="30" fxLayout="column">
        <div
          *ngIf="showInformationPane"
          ngClass.lt-md="margin top-1x"
          fxFlexOrder="1"
          fxFlexOrder.lt-md="3"
          [ngClass]="{ 'sticky top-4': stickyInfo }"
        >
          <div class="information-container">
            <div class="pad all-3x mat-elevation-z2 border-radius-4">
              <!-- Information (sticky) Container -->
              <ng-content select=".search-layout-information"></ng-content>
            </div>
          </div>
        </div>
        <div fxHide.gt-sm fxFlexOrder="2" fxFlexOrder.lt-md="2">
          <div platformEmptyHide>
            <ng-content
              select=".mobile-search-layout-page-container-header"
            ></ng-content>
          </div>
        </div>
        <div
          ngClass.gt-sm="margin top-4x"
          *ngIf="showFilterPane"
          fxFlexOrder="3"
          fxFlexOrder.lt-md="1"
          data-cy="two-column-card-search-layout.filter"
        >
          <!-- Filter Pane Container -->
          <ng-content select=".search-layout-filter-pane"></ng-content>
        </div>
      </div>
      <div fxFlex.gt-sm="70">
        <!-- Search Results Container -->
        <ng-content select=".search-layout-results"></ng-content>
      </div>
    </div>

    <!-- Loading Spinner -->
    <app-serp-loader
      *ngIf="isLoading"
      [cacheStatus]="'incomplete'"
      [suppressTopSection]="loaderSuppressTopSection"
    ></app-serp-loader>

    <div class="pad top-4x bottom-6x" *ngIf="!hasResults">
      <!-- No Results Container -->
      <ng-content select=".search-layout-no-results"></ng-content>
    </div>

    <!-- Footer Container -->
    <div class="margin top-2x" platformEmptyHide>
      <ng-content select=".search-layout-footer"></ng-content>
    </div>
  </platform-page-container>
</div>
